import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ReportCurrency,
  ReportType,
  ClientCustomCalendarModel,
} from '../../../../models';
import * as Styled from '../styled';
import DateRange, {
  DateRangeMode,
  DateRangeLabel,
} from '../date-range/DateRange';
import ReportSettingPIT from '../ReportSettingPIT';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';

interface ReportSettingSubleaseProps {
  onChange: (updatedValue: ReportSettingSubleaseState) => void;
  reportSettingState: ReportSettingSubleaseState;
  customCalendarSettings?: ClientCustomCalendarModel;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
}

export interface ReportSettingSubleaseState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  endDate: string;
  isBasedRentOnly: boolean;
  isValid: boolean;
}

function ReportDateSettingSublease({
  onChange,
  reportSettingState,
  customCalendarSettings,
  reportTypeSetting,
  isAllowPIT,
}: ReportSettingSubleaseProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = {
    Start: 'Start Date',
    End: 'End Date',
  };
  const mode =
    DateRangeMode[
      customCalendarSettings.isCustomCalendarEnabled
        ? 'CustomCalendar'
        : 'ShortDate'
    ];

  return (
    <>
      <DateRange
        onChange={useCallback(
          (startDate: string, endDate: string, isValid: boolean): void => {
            onChange({
              ...reportSettingState,
              startDate: startDate,
              endDate: endDate,
              isValid: isValid,
            });
          },
          [onChange, reportSettingState],
        )}
        startDate={reportSettingState.startDate}
        endDate={reportSettingState.endDate}
        mode={mode}
        dateRangeLabel={dateRangeLabel}
        customCalendarPeriods={customCalendarSettings.numberOfPeriods}
      />
      <Styled.Line />
      <ReportSettingPIT
        reportType={ReportType.sublease}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingSubleaseState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingSublease);
